import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class IconsService {
  /**
   * Constructor
   */
  constructor() {
    const domSanitizer = inject(DomSanitizer);
    const matIconRegistry = inject(MatIconRegistry);

    // Register icon sets
    matIconRegistry.addSvgIconSet(
      domSanitizer.bypassSecurityTrustResourceUrl(
        './icons/material-twotone.svg',
      ),
    );
    matIconRegistry.addSvgIconSetInNamespace(
      'mat_outline',
      domSanitizer.bypassSecurityTrustResourceUrl(
        './icons/material-outline.svg',
      ),
    );
    matIconRegistry.addSvgIconSetInNamespace(
      'mat_solid',
      domSanitizer.bypassSecurityTrustResourceUrl('./icons/material-solid.svg'),
    );
    matIconRegistry.addSvgIconSetInNamespace(
      'feather',
      domSanitizer.bypassSecurityTrustResourceUrl('./icons/feather.svg'),
    );
    matIconRegistry.addSvgIconSetInNamespace(
      'heroicons_outline',
      domSanitizer.bypassSecurityTrustResourceUrl(
        './icons/heroicons-outline.svg',
      ),
    );
    matIconRegistry.addSvgIconSetInNamespace(
      'heroicons_solid',
      domSanitizer.bypassSecurityTrustResourceUrl(
        './icons/heroicons-solid.svg',
      ),
    );
    matIconRegistry.addSvgIconSetInNamespace(
      'heroicons_mini',
      domSanitizer.bypassSecurityTrustResourceUrl('./icons/heroicons-mini.svg'),
    );

    matIconRegistry.addSvgIcon(
      'odin-voice',
      domSanitizer.bypassSecurityTrustResourceUrl(
        './icons/voice-icon-sidebar.svg',
      ),
    );
    matIconRegistry.addSvgIcon(
      'odin-fleet',
      domSanitizer.bypassSecurityTrustResourceUrl(
        './icons/fleet-icon-sidebar.svg',
      ),
    );
    matIconRegistry.addSvgIcon(
      'odin-cortex',
      domSanitizer.bypassSecurityTrustResourceUrl(
        './icons/cortex-icon-sidebar.svg',
      ),
    );
    matIconRegistry.addSvgIcon(
      'odin-rooms',
      domSanitizer.bypassSecurityTrustResourceUrl(
        './icons/rooms-icon-sidebar.svg',
      ),
    );

    // Engines and platforms the ODIN SDKs target (Voice "Get started"). From
    // Simple Icons (CC0); Font Awesome has Unity but neither Unreal nor C.
    for (const name of ['unity', 'unreal', 'typescript', 'c']) {
      matIconRegistry.addSvgIconInNamespace(
        'sdk',
        name,
        domSanitizer.bypassSecurityTrustResourceUrl(`./icons/sdk/${name}.svg`),
      );
    }

    // Font Awesome icon sets (used by Fleet module)
    matIconRegistry.addSvgIconSetInNamespace(
      'fa',
      domSanitizer.bypassSecurityTrustResourceUrl('./icons/fa-light.svg'),
    );
    matIconRegistry.addSvgIconSetInNamespace(
      'fab',
      domSanitizer.bypassSecurityTrustResourceUrl('./icons/fa-brands.svg'),
    );
  }
}
